// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Advertisement__content-da0ce1 {
  padding: 0 16px;
  margin-top: 16px;
  color: var(--base-110);
  font: var(--font-body-4);
  letter-spacing: var(--font-spacing-body-4);
}

.Advertisement__media-container-a8c03a {
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
  overflow: hidden;
  max-width: 100%;
  background-size: cover;
  background-color: inherit;
}

.Advertisement__image-daa44f {
  max-height: 100%;
  max-width: 100%;
}

.Advertisement__button-cd5ea2 {
  width: 100%;
  margin-top: 8px;
  margin-bottom: 8px;
  font: var(--font-body-2);
  letter-spacing: var(--font-spacing-body-2);
  text-decoration: none;
}

.Advertisement__badge-dd3f34 {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  color: var(--base-80);
  background-color: var(--base-40);
  height: 20px;
  width: 22px;
  margin-inline-end: 8px;
  vertical-align: middle;
  font: var(--font-caption-4);
  border-radius: 2px;
}

.Advertisement__badge-dd3f34:before {
  content: "Ad";
}`, "",{"version":3,"sources":["webpack://./src/main/ChatView/Messages/Message/Payload/Advertisement/styles.m.css"],"names":[],"mappings":"AAAA;EACE,eAAA;EACA,gBAAA;EACA,sBAAA;EACA,wBAAA;EACA,0CAAA;AACF;;AAEA;EACE,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,sBAAA;EACA,yBAAA;AACF;;AAEA;EACE,gBAAA;EACA,eAAA;AACF;;AAEA;EACE,WAAA;EACA,eAAA;EACA,kBAAA;EACA,wBAAA;EACA,0CAAA;EACA,qBAAA;AACF;;AAEA;EACE,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,qBAAA;EACA,gCAAA;EACA,YAAA;EACA,WAAA;EACA,sBAAA;EACA,sBAAA;EACA,2BAAA;EACA,kBAAA;AACF;;AAEA;EACE,aAAA;AACF","sourcesContent":[".content {\n  padding: 0 16px;\n  margin-top: 16px;\n  color: var(--base-110);\n  font: var(--font-body-4);\n  letter-spacing: var(--font-spacing-body-4);\n}\n\n.media-container {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  position: relative;\n  overflow: hidden;\n  max-width: 100%;\n  background-size: cover;\n  background-color: inherit;\n}\n\n.image {\n  max-height: 100%;\n  max-width: 100%;\n}\n\n.button {\n  width: 100%;\n  margin-top: 8px;\n  margin-bottom: 8px;\n  font: var(--font-body-2);\n  letter-spacing: var(--font-spacing-body-2);\n  text-decoration: none;\n}\n\n.badge {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  color: var(--base-80);\n  background-color: var(--base-40);\n  height: 20px;\n  width: 22px;\n  margin-inline-end: 8px;\n  vertical-align: middle;\n  font: var(--font-caption-4);\n  border-radius: 2px;\n}\n\n.badge:before {\n  content: 'Ad';\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"content": `Advertisement__content-da0ce1`,
	"media-container": `Advertisement__media-container-a8c03a`,
	"mediaContainer": `Advertisement__media-container-a8c03a`,
	"image": `Advertisement__image-daa44f`,
	"button": `Advertisement__button-cd5ea2`,
	"badge": `Advertisement__badge-dd3f34`
};
module.exports = ___CSS_LOADER_EXPORT___;
